export const english = {
    'This charge includes extra vehicle charge':
        'This charge includes extra vehicle charge',
    'and bad weather charge': 'and bad weather charge',
    only: 'only',
    'for demo propose use otp 123456': 'for demo propose use otp 123456',
    'Nutrition Details': 'Nutrition Details',
    'Highlights for you': 'Highlights for you',
    'Allergic Ingredients': 'Allergic Ingredients',
    'items available': 'items available',
    'Welcome to React and react-i18next': 'Welcome to React and react-i18next',
    'Or Login with': 'Or Login with',
    'Dont have a cutlery? Restaurant will provide you.':
        'Dont have a cutlery? Restaurant will provide you.',
    'Minimum Order': 'Minimum Order',
    'Choose Food from  your Favourite Restaurants':
        'Choose Food from  your Favourite Restaurants',
    'Sharing your accurate location enhances precision in search results and delivery estimates, ensures effortless order delivery.':
        'Sharing your accurate location enhances precision in search results and delivery estimates, ensures effortless order delivery.',
    'Active from - ': 'Active from - ',
    'Enter Voucher': 'Enter Voucher',
    'This is a halal food': 'This is a halal food',
    'Sent attachment': 'Sent attachment',
    'No Promo Available!': 'No Promo Available!',
    'Please add manually or collect promo from':
        'Please add manually or collect promo from',
    'Payment Verification Failed !': 'Payment Verification Failed !',
    'Chef has started cooking ': 'Chef has started cooking ',
    'Tell us what’s wrong with the order ?':
        'Tell us what’s wrong with the order ?',
    'You payment is declined by admin. Please contact with admin for further query':
        'You payment is declined by admin. Please contact with admin for further query',
    'Type your address here or pick from map':
        'Type your address here or pick from map',
    'Select from saved addresses or pick from map':
        'Select from saved addresses or pick from map',
    'Sign up with': 'Sign up with',
    'Share your valuable feedback': 'Share your valuable feedback',
    'Today Available Till': 'Today Available Till',
    '*min purchase': '*min purchase',
    'Delivery Man Information': 'Delivery Man Information',
    'You’ll get your order weekly at': 'You’ll get your order weekly at',
    'You’ll get your order daily at': 'You’ll get your order daily at',
    'You’ll get your order timely': 'You’ll get your order timely',
    Upcoming: 'Upcoming',
    'Add Cutlery': 'Add Cutlery',
    '(Order Amount)': '(Order Amount)',
    'Today’s Trends': 'Today’s Trends',
    'Popular  Foods Nearby': 'Popular  Foods Nearby',
    "What's on Your Mind?": "What's on Your Mind?",
    'has been copied': 'has been copied',
    'No Contact Info Added': 'No Contact Info Added',
    'Track Your Order': 'Track Your Order',
    'Search Order': 'Search Order',
    'Valid until': 'Valid until',
    'Remaining Wallet Balance': 'Remaining Wallet Balance',
    'If Any product is not available': 'If Any product is not available',
    'Add More Delivery Instruction': 'Add More Delivery Instruction',
    'If you want to add fund to your wallet then click add fund button':
        'If you want to add fund to your wallet then click add fund button',
    'maximum image upload limit 5': 'maximum image upload limit 5',
    Category: 'Category',
    'Additional Note': 'Additional Note',
    'Minimum purchase amount': 'Minimum purchase amount',
    'Currently Available': 'Currently Available',
    'FIND YOUR HAPPINESS': 'FIND YOUR HAPPINESS',
    'For the love of delicious food.': 'For the love of delicious food.',
    'No restaurant is available right now':
        'No restaurant is available right now',
    Email: 'Email',
    Joined: 'Joined',
    'No Subtitle Found': 'No Subtitle Found',
    'Term & Conditions': 'Term & Conditions',
    Other: 'Other',
    'Best Selling Restaurants': 'Best Selling Restaurants',
    'Popular Restaurants': 'Popular Restaurants',
    'New Restaurants': 'New Restaurants',
    'Search foods and restaurants....': 'Search foods and restaurants....',
    'Positive Review': 'Positive Review',
    wallets: 'wallets',
    'Coupon Code': 'Coupon Code',
    Code: 'Code',
    'Restaurants Information': 'Restaurants Information',
    'What’s Wrong With This Order?': 'What’s Wrong With This Order?',
    'No Order found': 'No Order found',
    refunded: 'refunded',
    'Wish List': 'Wish List',
    'Register as seller and open shop in':
        'Register as seller and open shop in',
    'to start your business': 'to start your business',
    Inbox: 'Inbox',
    Ongoing: 'Ongoing',
    Previous: 'Previous',
    inbox: 'inbox',
    Password: 'Password',
    'Register as delivery man and earn money':
        'Register as delivery man and earn money',
    'All the best restaurants are one click away':
        'All the best restaurants are one click away',
    'Remember me': 'Remember me',
    'Forgot Password': 'Forgot Password',
    'Popular in your area': 'Popular in your area',
    Login: 'Login',
    'Special Food Offers': 'Special Food Offers',
    'Want to login to your services ?': 'Want to login to your services ?',
    'Login here': 'Login here',
    Dashboardd: 'Dashboardd',
    New: 'New',
    'Start a new message': 'Start a new message',
    'Earn money to your wallet by completing the offer & challenged':
        'Earn money to your wallet by completing the offer & challenged',
    Copyright: 'Carrot FooDelivery',
    'My Addresses': 'My Addresses',
    Add: 'Add',
    wallet: 'wallet',
    processing: 'processing',
    refund_request_canceled: 'refund_request_canceled',
    'Refund cancellation note:': 'Refund cancellation note:',
    'Refund request note:': 'Refund request note:',
    refund_requested: 'refund_requested',
    'Add Address': 'Add Address',
    'Edit Profile': 'Edit Profile',
    'Products in wishlist': 'Products in wishlist',
    wishlist: 'wishlist',
    'Personal Details': 'Personal Details',
    'Wallet History': 'Wallet History',
    bonus: 'bonus',
    'I agree that placing the order places me under':
        'I agree that placing the order places me under',
    'Terms and Conditions': 'Terms and Conditions',
    'added via': 'added via',
    'No Save Address Found': 'No Save Address Found',
    'How to use': 'How to use',
    'Total Point': 'Total Point',
    'Collect Cash': 'Collect Cash',
    'Open Confirm Dialog': 'Open Confirm Dialog',
    'Confirm this request ? ': 'Confirm this request ? ',
    Cancel: 'Cancel',
    Yes: 'Yes',
    Download: 'Download',
    Filter: 'Filter',
    'Zone Name': 'Zone Name',
    Providers: 'Providers',
    Services: 'Services',
    Status: 'Status',
    Action: 'Action',
    'My Account': 'My Account',
    Mails: 'Mails',
    Notifications: 'Notifications',
    Restaurants: 'Restaurants',
    Categories: 'Categories',
    'SOME COMPONENTS': 'SOME COMPONENTS',
    Components: 'Components',
    Tables: 'Tables',
    Alerts: 'Alerts',
    Toasters: 'Toasters',
    Dialogs: 'Dialogs',
    'Form with formik': 'Form with formik',
    Charts: 'Charts',
    'Provider Details': 'Provider Details',
    'Multistep Form With Steppers': 'Multistep Form With Steppers',
    'SERVICE MANAGEMENT': 'SERVICE MANAGEMENT',
    'Service Zones': 'Service Zones',
    'Service Categories': 'Service Categories',
    'Category Setup': 'Category Setup',
    'Sub Category Setup': 'Sub Category Setup',
    'Service List': 'Service List',
    'Upload File': 'Upload File',
    'On Demand Service': 'On Demand Service',
    'Page not found': 'Page not found',
    'Go Back Home': 'Go Back Home',
    'Sign In': 'Sign In',
    'Sign in to stay connected.': 'Sign in to stay connected.',
    'Collect Cash From Provider': 'Collect Cash From Provider',
    Edit: 'Edit',
    'Information Details': 'Information Details',
    'This field is required': 'This field is required',
    'Payment Method': 'Payment Method',
    'Name on card': 'Name on card',
    'Card Number': 'Card Number',
    Back: 'Back',
    Next: 'Next',
    'Review Your Order': 'Review Your Order',
    'Shipping Address': 'Shipping Address',
    'First Name': 'First Name',
    'Last Name': 'Last Name',
    Address: 'Address',
    'Payment Details': 'Payment Details',
    'Place Order': 'Place Order',
    'Company / Individual name is required':
        'Company / Individual name is required',
    'Phone number is not valid': 'Phone number is not valid',
    'Phone number is required': 'Phone number is required',
    'Address is required': 'Address is required',
    'File is required*': 'File is required*',
    'Name is required': 'Name is required',
    'Phone is required': 'Phone is required',
    'Must be a valid email': 'Must be a valid email',
    'Email is required': 'Email is required',
    'No password provided.': 'No password provided.',
    'Password is too short - should be 8 chars minimum.':
        'Password is too short - should be 8 chars minimum.',
    'Passwords must match': 'Passwords must match',
    'Form With Formik': 'Form With Formik',
    'General Information': 'General Information',
    'Company / Individual Name': 'Company / Individual Name',
    'Add New Provider': 'Add New Provider',
    'Business Information': 'Business Information',
    'Select Identity Type': 'Select Identity Type',
    'Contact Person': 'Contact Person',
    'Same as general information': 'Same as general information',
    'Account Information': 'Account Information',
    'Confirm Password': 'Confirm Password',
    Submit: 'Submit',
    Reset: 'Reset',
    'Filter your order': 'Filter your order',
    'Select Date Range': 'Select Date Range',
    'Select Categories': 'Select Categories',
    'Select  Sub Categories': 'Select  Sub Categories',
    'Select  Zones': 'Select  Zones',
    'Clear all Filter': 'Clear all Filter',
    'Open Delete Dialog': 'Open Delete Dialog',
    'Are Your Sure You Want to Delete This Zone ?':
        'Are Your Sure You Want to Delete This Zone ?',
    'This operation cannot be undone': 'This operation cannot be undone',
    'No, Keep this ': 'No, Keep this ',
    'Yes, Delete': 'Yes, Delete',
    'Provider Details With Cards and Tabs':
        'Provider Details With Cards and Tabs',
    Search: 'Search',
    Logout: 'Logout',
    Overview: 'Overview',
    'Subscribed Services': 'Subscribed Services',
    Orders: 'Orders',
    'Service Man List': 'Service Man List',
    Settings: 'Settings',
    Reviews: 'Reviews',
    settings: 'settings',
    Phone: 'Phone',
    Deny: 'Deny',
    Accept: 'Accept',
    'Paid by wallet': 'Paid by wallet',
    'Delivery instruction': 'Delivery instruction',
    'Unavailable item note': 'Unavailable item note',
    Cutlery: 'Cutlery',
    'Ex: Please provide an extra napkin': 'Ex: Please provide an extra napkin',
    'Cash On Delivery': 'Cash On Delivery',
    Select: 'Select',
    'Pay via Wallet': 'Pay via Wallet',
    'Add Payment Method': 'Add Payment Method',
    'Coupon code': 'Coupon code',
    'Place an order and enjoy': 'Place an order and enjoy',
    Name: 'Name',
    'Identity Number': 'Identity Number',
    'Order Otp': 'Order Otp',
    'Search a category': 'Search a category',
    'Search location here...': 'Search location here...',
    'Pick Form Map': 'Pick Form Map',
    'Set Location': 'Set Location',
    'Rows Per Page': 'Rows Per Page',
    Checkout: 'Checkout',
    'Shipping address': 'Shipping address',
    'Payment details': 'Payment details',
    order: 'order',
    'Review your order': 'Review your order',
    'First name is required': 'First name is required',
    'Last name is required': 'Last name is required',
    'Address Form': 'Address Form',
    'items selected': 'items selected',
    'Image Format - JPG, Pong, ZPEG, GIF Image Size - Maximum Size 2Mb Image Ratio - 1: 1':
        'Image Format - JPG, Pong, ZPEG, GIF Image Size - Maximum Size 2Mb Image Ratio - 1: 1',
    'Order Id': 'Order Id',
    'Order Amount': 'Order Amount',
    'Track Order': 'Track Order',
    'Features Catagories': 'Features Catagories',
    Food: 'Food',
    Campaigns: 'Campaigns',
    'Best Reviewed Foods': 'Best Reviewed Foods',
    'View all': 'View all',
    'New On StackFood': 'New On Carrot FooDelivery',
    'Popular Restaurant': 'Popular Restaurant',
    'Popular Food Nearby': 'Popular Food Nearby',
    Nearby: 'Nearby',
    'Best Resturants': 'Best Resturants',
    'Filter By': 'Filter By',
    'See more': 'See more',
    All: 'All',
    'Top Rated': 'Top Rated',
    Veg: 'Veg',
    '(Veg)': '(Veg)',
    'Newly Joined': 'Newly Joined',
    'Non-Veg': 'Non-Veg',
    '(Non-Veg)': '(Non-Veg)',
    'Sort Grid': 'Sort Grid',
    'Sort by': 'Sort by',
    Discounted: 'Discounted',
    'Your Favourites': 'Your Favourites',
    view: 'view',
    'New Arrivals': 'New Arrivals',
    'Ratings 4 +': 'Ratings 4 +',
    'We found': 'We found',
    'foods for you': 'foods for you',
    restaurants: 'restaurants',
    food: 'food',
    Description: 'Description',
    'Add to cart': 'Add to cart',
    'Total Amount': 'Total Amount',
    'Add Ons (OPTIONAL)': 'Add Ons (OPTIONAL)',
    'Select Variations': 'Select Variations',
    'Starts from': 'Starts from',
    Capacity: 'Capacity',
    'Add to favorite': 'Add to favorite',
    'Minimum Order Value': 'Minimum Order Value',
    'Delivery Time': 'Delivery Time',
    Ratings: 'Ratings',
    Rating: 'Rating',
    Offer: 'Offer',
    'Expired on': 'Expired on',
    Purchase: 'Purchase',
    'Min purchase': 'Min purchase',
    'Only for': 'Only for',
    'Only for some specific zones': 'Only for some specific zones',
    Restaurant: 'Restaurant',
    Max: 'Max',
    'Code copied!': 'Code copied!',
    'Active Order': 'Active Order',
    'Past Order': 'Past Order',
    'Resturant Informations': 'Resturant Informations',
    'Payment Status': 'Payment Status',
    'Order Status': 'Order Status',
    Amount: 'Amount',
    'Payment method': 'Payment method',
    'Order placed': 'Order placed',
    Order: 'Order',
    'Follow us on': 'Follow us on',
    '24/7 Helpline': '24/7 Helpline',
    'DELIVERY DETAILS': 'DELIVERY DETAILS',
    'Delivery Options': 'Delivery Options',
    'Home Delivery': 'Home Delivery',
    'Take Away': 'Take Away',
    'Preferable Time': 'Preferable Time',
    'Already have an account?': 'Already have an account?',
    "Don't have an account?": "Don't have an account?",
    Time: 'Time',
    Today: 'Today',
    Tomorrow: 'Tomorrow',
    Subtotal: 'Subtotal',
    Discount: 'Discount',
    'Payment Options': 'Payment Options',
    'Cash on delivery': 'Cash on delivery',
    'cash on delivery': 'cash on delivery',
    'Digital payment': 'Digital payment',
    'Wallet payment': 'Wallet payment',
    'Please double check your order and address details, Order Cannot be CANCELLED once accepted by Restaurant.':
        'Please double check your order and address details, Order Cannot be CANCELLED once accepted by Restaurant.',
    'Have a Coupon?': 'Have a Coupon?',
    'Apply Now': 'Apply Now',
    'View Saved Address': 'View Saved Address',
    'Delivery Address': 'Delivery Address',
    ' Add new address': ' Add new address',
    ' Add New +': ' Add New +',
    'Address Type': 'Address Type',
    Home: 'Home',
    Office: 'Office',
    Others: 'Others',
    'Contact Person Name': 'Contact Person Name',
    'Contact Person Number': 'Contact Person Number',
    'Street Number': 'Street Number',
    'Transaction History': 'Transaction History',
    'AUTHENTIC ASIAN CUISINE': 'AUTHENTIC ASIAN CUISINE',
    'BEST TACOS AROUND': 'BEST TACOS AROUND',
    'Fast Home Delivery': 'Fast Home Delivery',
    'DISCOUNT UPTO 20%': 'DISCOUNT UPTO 20%',
    'for Chinese, Japanese & Asian foods':
        'for Chinese, Japanese & Asian foods',
    Foods: 'Foods',
    'Starts From:': 'Starts From:',
    'Download our app from google play store & app store.':
        'Download our app from google play store & app store.',
    'I agree with the terms & conditions':
        'I agree with the terms & conditions',
    'Item added to cart': 'Item added to cart',
    'You are not logged in': 'You are not logged in',
    Free: 'Free',
    'Login Information': 'Login Information',
    'Owner Information': 'Owner Information',
    'Delivery Man Image': 'Delivery Man Image',
    'Loyalty Points !': 'Loyalty Points !',
    'Search your desired foods ': 'Search your desired foods ',
    'file Upload': 'file Upload',
    'Delivery Man Type': 'Delivery Man Type',
    Zone: 'Zone',
    'Identity Type': 'Identity Type',
    'VAT/TEX': 'VAT/TEX',
    'Restaurant Address': 'Restaurant Address',
    'Restaurant Name': 'Restaurant Name',
    'restaurant address required': 'restaurant address required',
    'restaurant name required': 'restaurant name required',
    'Minimum Delivery Time': 'Minimum Delivery Time',
    Logo: 'Logo',
    Items: 'Items',
    'Coupon Applied': 'Coupon Applied',
    Paid: 'Paid',
    Unpaid: 'Unpaid',
    'Order Summery': 'Order Summery',
    'Your food will be delivered within': 'Your food will be delivered within',
    'Back to home': 'Back to home',
    'Order Place Failed': 'Order Place Failed',
    "Order didn't place successfully.": "Order didn't place successfully.",
    'Are you sure you want to cancel this order?':
        'Are you sure you want to cancel this order?',
    'On First Order': 'On First Order',
    'Delivery man doesnt assigned': 'Delivery man doesnt assigned',
    'Delivery man has not been assigned': 'Delivery man has not been assigned',
    'Not Available now': 'Not Available now',
    'Available will be': 'Available will be',
    'non-veg': 'non-veg',
    veg: 'veg',
    'Delivering to': 'Delivering to',
    'Switch to cash on delivery': 'Switch to cash on delivery',
    'Switch Your payment method ': 'Switch Your payment method ',
    'Are you sure you want to switch this order to Cash On Delivery?':
        'Are you sure you want to switch this order to Cash On Delivery?',
    'Payment Failed': 'Payment Failed',
    'My Orders': 'My Orders',
    Change: 'Change',
    'Added to favorite successfully.': 'Added to favorite successfully.',
    'Removed from  favorite successfully.':
        'Removed from  favorite successfully.',
    'Something went wrong.': 'Something went wrong.',
    Remove: 'Remove',
    'Applied !': 'Applied !',
    'You have balance in  your wallet': 'You have balance in  your wallet',
    'Has  paid by your wallet.': 'Has  paid by your wallet.',
    'Do you want to use now?': 'Do you want to use now?',
    Use: 'Use',
    ' Update': ' Update',
    'Coupon Copied': 'Coupon Copied',
    'Wallet Amount': 'Wallet Amount',
    Language: 'Language',
    'Identity number Is A Required Field':
        'Identity number Is A Required Field',
    'Delivery man image is required': 'Delivery man image is required',
    'Logged in successfully': 'Logged in successfully',
    'Terms & Conditions': 'Terms & Conditions',
    'Privacy Policy': 'Privacy Policy',
    'Quick Links': 'Quick Links',
    'Contact Us': 'Contact Us',
    'About Us': 'About Us',
    ' Loyalty Points': ' Loyalty Points',
    'My account': 'My account',
    Delivery: 'Delivery',
    ' Take away': ' Take away',
    'Please search some keywords.': 'Please search some keywords.',
    'Are you sure you want to delete this address?':
        'Are you sure you want to delete this address?',
    'No food found': 'No food found',
    'No restaurant found': 'No restaurant found',
    'You cannot order from multiple restaurants in a single order':
        'You cannot order from multiple restaurants in a single order',
    'You have food from another restaurant in cart. If you continue, your all previous food from cart will be removed':
        'You have food from another restaurant in cart. If you continue, your all previous food from cart will be removed',
    'Are you sure, you want to reset?': 'Are you sure, you want to reset?',
    'Please Choose a delivery address.': 'Please Choose a delivery address.',
    'You denied location permission. Please allow browsers location permission from your device, refresh the site and receive more accurate delivery.':
        'You denied location permission. Please allow browsers location permission from your device, refresh the site and receive more accurate delivery.',
    Variation: 'Variation',
    Addon: 'Addon',
    'You place the order successfully.': 'You place the order successfully.',
    'Your order is placed Successfully. We start our delivery process and you will receive your food soon':
        'Your order is placed Successfully. We start our delivery process and you will receive your food soon',
    'Congratulations!': 'Congratulations!',
    'One or more item is not available for the chosen preferable schedule time.':
        'One or more item is not available for the chosen preferable schedule time.',
    'Download app to enjoy more!': 'Download app to enjoy more!',
    'FIND BEST RESTAURANTS NEAR YOU': 'FIND BEST RESTAURANTS NEAR YOU',
    'Pick Locations': 'Pick Locations',
    'Best Reviewed Food': 'Best Reviewed Food',
    'Need Any help?': 'Need Any help?',
    'Communicate with our support team to get proper guidance to your quaternaries.':
        'Communicate with our support team to get proper guidance to your quaternaries.',
    'VISIT US': 'VISIT US',
    'EMAIL US': 'EMAIL US',
    'CALL US': 'CALL US',
    'write something': 'write something',
    'Restaurant Registration': 'Restaurant Registration',
    'Logo is required': 'Logo is required',
    'Cover photo is required': 'Cover photo is required',
    'Please search a location first.': 'Please search a location first.',
    'New location has been set.': 'New location has been set.',
    'Popular Foods Nearby': 'Popular Foods Nearby',
    'Please exchange more than': 'Please exchange more than',
    points: 'points',
    Popular: 'Popular',
    debit: 'debit',
    credit: 'credit',
    'No Favourite Restaurant Found': 'No Favourite Restaurant Found',
    'No Favourite Food Found': 'No Favourite Food Found',
    'Delivery man': 'Delivery man',
    'Trip Route': 'Trip Route',
    away: 'away',
    'Order placed at': 'Order placed at',
    'Search Result for': 'Search Result for',
    'Enter phone number': 'Enter phone number',
    'Free Delivery': 'Free Delivery',
    'Open Your Own Virtual Restaurant On':
        'Open Your Own Virtual Restaurant On',
    'Join as delivery man on': 'Join as delivery man on',
    'Lets Connect !': 'Lets Connect !',
    'Stay upto date with restaurants and foods around you':
        'Stay upto date with restaurants and foods around you',
    'Best Restaurants Near Your Location':
        'Best Restaurants Near Your Location',
    'Light Mode': 'Light Mode',
    'Dark Mode': 'Dark Mode',
    'Food Campaigns': 'Food Campaigns',
    'All Restaurants': 'All Restaurants',
    History: 'History',
    Suggestions: 'Suggestions',
    off: 'off',
    'Days Since Joining': 'Days Since Joining',
    'amount in wallet': 'amount in wallet',
    Coupons: 'Coupons',
    coupons: 'coupons',
    Wallets: 'Wallets',
    Seller: 'Seller',
    'Delivery Man': 'Delivery Man',
    'Your Address': 'Your Address',
    'Loyalty Points': 'Loyalty Points',
    'Order placed ': 'Order placed ',
    "Restaurant Information's": "Restaurant Information's",
    'Items Price': 'Items Price',
    'Addons Price': 'Addons Price',
    'Coupon Discount': 'Coupon Discount',
    'Deliver to the front door': 'Deliver to the front door',
    'Deliver to the reception desk': 'Deliver to the reception desk',
    'Avoid calling phone': 'Avoid calling phone',
    'Come with no sound': 'Come with no sound',
    'Remove it form my cart': 'Remove it form my cart',
    'I will wait until it is restocked': 'I will wait until it is restocked',
    'Please cancel the order': 'Please cancel the order',
    'Call me ASAP': 'Call me ASAP',
    'Notify me when it is back': 'Notify me when it is back',
    VAT: 'VAT',
    'Delivery Fee': 'Delivery Fee',
    'Share your opinion': 'Share your opinion',
    'Rate the food': 'Rate the food',
    Quantity: 'Quantity',
    'Rate the deliveryman': 'Rate the deliveryman',
    'I agree that placing the order places me under Terms and Conditions & Privacy Policies':
        'I agree that placing the order places me under Terms and Conditions & Privacy Policies',
    'Delivery Man Tips': 'Delivery Man Tips',
    'It Will Add To Your Balance When The Order Is Delivered':
        'It Will Add To Your Balance When The Order Is Delivered',
    'You Have Earned Point': 'You Have Earned Point',
    'Enjoy Off On All Foods': 'Enjoy Off On All Foods',
    'Discount Available From': 'Discount Available From',
    'Minimum Purchase Value': 'Minimum Purchase Value',
    'Max Discount ': 'Max Discount ',
    'Search foods': 'Search foods',
    'Search foods in restaurant ': 'Search foods in restaurant ',
    'Filter Your Search Results': 'Filter Your Search Results',
    'Currently Available Foods': 'Currently Available Foods',
    'Discounted Foods': 'Discounted Foods',
    'clear all filter': 'clear all filter',
    'ascending (A-Z)': 'ascending (A-Z)',
    'descending (Z-A)': 'descending (Z-A)',
    'Point History': 'Point History',
    'Convert your loyalty point to wallet money.':
        'Convert your loyalty point to wallet money.',
    'Send your wallet money while order': 'Send your wallet money while order',
    'Are You Sure You Want To Delete ?': 'Are You Sure You Want To Delete ?',
    'Are You Sure You Want To Logout?': 'Are You Sure You Want To Logout?',
    'Amin also reward their top customers with wallet money':
        'Amin also reward their top customers with wallet money',
    'Minimum 200 points required to convert into currency':
        'Minimum 200 points required to convert into currency',
    'Only for  Restaurant': 'Only for  Restaurant',
    'Convert your loyalty points into wallet money':
        'Convert your loyalty points into wallet money',
    'Total Balance': 'Total Balance',
    'Connect with our social media and other sites to keep up to date':
        'Connect with our social media and other sites to keep up to date',
    '% OFF': '% OFF',
    'Select a Payment Method to Proceed': 'Select a Payment Method to Proceed',
    'Pay Via Online': 'Pay Via Online',
    '% off on all items!': '% off on all items!',
    'off on all items!': 'off on all items!',
    Register: 'Register',
    'Use Current Location': 'Use Current Location',
    Profile: 'Profile',
    'Stay upto date with restaurants and foods around you. Subscribe with email.':
        'Stay upto date with restaurants and foods around you. Subscribe with email.',
    'Personal Info': 'Personal Info',
    'Fast Name': 'Fast Name',
    'Not Changeable': 'Not Changeable',
    'Add New +': 'Add New +',
    'Add new address': 'Add new address',
    'Convert to Currency': 'Convert to Currency',
    'Your loyalty point will convert to currency and transfer to wallet':
        'Your loyalty point will convert to currency and transfer to wallet',
    point: 'point',
    'Your Profile': 'Your Profile',
    'No Coupon Found': 'No Coupon Found',
    'Search a restaurant': 'Search a restaurant',
    'Closed Now': 'Closed Now',
    Min: 'Min',
    '% off on all foods': '% off on all foods',
    Enjoy: 'Enjoy',
    'Discount available from': 'Discount available from',
    'Search foods in restaurant': 'Search foods in restaurant',
    Off: 'Off',
    'Only For': 'Only For',
    OFF: 'OFF',
    'Days since Joining': 'Days since Joining',
    'Amount in Wallet': 'Amount in Wallet',
    'Delivery fee': 'Delivery fee',
    'You have earned': 'You have earned',
    'Minimum purchase value': 'Minimum purchase value',
    'Max Discount': 'Max Discount',
    'Cart is Empty': 'Cart is Empty',
    'in your cart': 'in your cart',
    Price: 'Price',
    min: 'min',
    'Clear All': 'Clear All',
    'Total Price': 'Total Price',
    'Wallet balance is below total amount':
        'Wallet balance is below total amount',
    'Selected Address': 'Selected Address',
    'Enter Your Coupon..': 'Enter Your Coupon..',
    'Order Summary': 'Order Summary',
    Total: 'Total',
    'Restaurant Informations': 'Restaurant Informations',
    'Give a review': 'Give a review',
    'Cancel Order': 'Cancel Order',
    'Order Confirmed': 'Order Confirmed',
    'Preparing Food': 'Preparing Food',
    'Food is on the way': 'Food is on the way',
    Delivered: 'Delivered',
    'Give Review': 'Give Review',
    'Amount Successfully added': 'Amount Successfully added',
    'Are you sure you want to  delete this item?':
        'Are you sure you want to  delete this item?',
    'Select and start messaging!': 'Select and start messaging!',
    'Leave a message': 'Leave a message',
    'Your order is placed Successfully. We start our delivery process and you will receive your food soon.':
        'Your order is placed Successfully. We start our delivery process and you will receive your food soon.',
    'point.': 'point.',
    'It will add to your balance when the order is delivered.':
        'It will add to your balance when the order is delivered.',
    'You must be login to access this page.':
        'You must be login to access this page.',
    'You must pick a zone to access this page.':
        'You must pick a zone to access this page.',
    'Your Email Address': 'Your Email Address',
    Join: 'Join',
    'Please insert a valid email.': 'Please insert a valid email.',
    'You must accept the': 'You must accept the',
    'Terms and conditions': 'Terms and conditions',
    'Forgot password?': 'Forgot password?',
    'Sign Up': 'Sign Up',
    'Send us mails': 'Send us mails',
    'Find us here': 'Find us here',
    'My Wallet': 'My Wallet',
    'Payment amount can not be 0': 'Payment amount can not be 0',
    'Become a restaurant owner': 'Become a restaurant owner',
    'Become a delivery man': 'Become a delivery man',
    'Help & Support': 'Help & support',
    'Open your own  virtual restaurant on':
        'Open your own  virtual restaurant on',
    'Are you sure you want to  logout?': 'Are you sure you want to  logout?',
    'Clear Cart': 'Clear Cart',
    'Recommend Products': 'Recommend Products',
    'Add fund': 'Add fund',
    'Order Now': 'Order Now',
    'To select from saved addresses, you need to sign in.':
        'To select from saved addresses, you need to sign in.',
    'Due Payment': 'Due Payment',
    'partially paid amount': 'partially paid amount',
    'Location is required.': 'Location is required.',
    'Valid till': 'Valid till',
    Agree: 'Agree',
    'You have to add min': 'You have to add min',
    'fund to get max of': 'fund to get max of',
    'All Transaction': 'All Transaction',
    'Order Transaction': 'Order Transaction',
    'Loyalty Points Transaction': 'Loyalty Points Transaction',
    'Referrer Transactions': 'Referrer Transactions',
    'Add Fund': 'Add Fund',
    Okay: 'Okay',
    Close: 'Close',
    Favorites: 'Favorites',
    'Pick from map': 'Pick from map',
    Or: 'Or',
    'Delivery Addresses': 'Delivery Addresses',
    'VAT/TAX': 'VAT/TAX',
    'Maximum Delivery Time': 'Maximum Delivery Time',
    'Cover Photo': 'Cover Photo',
    Latitude: 'Latitude',
    Longitude: 'Longitude',
    'Confirm Password required': 'Confirm Password required',
    'last name required': 'last name required',
    'phone number required': 'phone number required',
    'vat is required': 'vat is required',
    'Identity Image': 'Identity Image',
    'Password is required': 'Password is required',
    Passport: 'Passport',
    Nid: 'Nid',
    FreeLancer: 'FreeLancer',
    Salary: 'Salary',
    'Signup successfully.': 'Signup successfully.',
    'Please enter your register Mobile Number':
        'Please enter your register Mobile Number',
    'Enter your password': 'Enter your password',
    Done: 'Done',
    'field is empty': 'field is empty',
    Verify: 'Verify',
    take_away: 'take_away',
    Delete: 'Delete',
    Now: 'Now',
    Schedule: 'Schedule',
    Qty: 'Qty',
    order_place: 'order_place',
    loyalty_point: 'loyalty_point',
    add_fund_by_admin: 'add_fund_by_admin',
    point_to_wallet: 'point_to_wallet',
    pending: 'pending',
    Pending: 'Pending',
    picked_up: 'picked_up',
    accepted: 'accepted',
    confirmed: 'confirmed',
    canceled: 'canceled',
    cash_on_delivery: 'cash_on_delivery',
    delivered: 'delivered',
    Messages: 'Messages',
    Comment: 'Comment',
    handover: 'handover',
    'You have no channels.': 'You have no channels.',
    Admin: 'Admin',
    'delivery man': 'delivery man',
    vendor: 'vendor',
    'Delete My Account': 'Delete My Account',
    'Refund Request': 'Refund Request',
    'Select an option': 'Select an option',
    'Submit Refund Request': 'Submit Refund Request',
    Note: 'Note',
    'Please select a reason': 'Please select a reason',
    'Maximum 3 images can be send at a time.':
        'Maximum 3 images can be send at a time.',
    'No saved addresses found to select.':
        'No saved addresses found to select.',
    'Deliveryman Registration': 'Deliveryman Registration',
    foods: 'foods',
    House: 'House',
    Floor: 'Floor',
    'No Data Found': 'No Data Found',
    'No location found.': 'No location found.',
    'Item updated successfully': 'Item updated successfully',
    'Logged out successfully': 'Logged out successfully',
    'No title given': 'No title given',
    'Best reviewed Foods': 'Best reviewed Foods',
    on: 'on',
    'Language Changed Successfully.': 'Language Changed Successfully.',
    'can not remain without selection.': 'can not remain without selection.',
    'Refund Policy': 'Refund Policy',
    'Shipping Policy': 'Shipping Policy',
    'Please give a phone number': 'Please give a phone number',
    'Cancellation Policy': 'Cancellation Policy',
    'This Variation needs to be selected in between minimum':
        'This Variation needs to be selected in between minimum',
    'and maximum': 'and maximum',
    'You must accept the terms and conditions':
        'You must accept the terms and conditions',
    'Refer Code (Optional)': 'Refer Code (Optional)',
    'items.': 'items.',
    'Suggested Searches': 'Suggested Searches',
    'Popular Cuisine': 'Popular Cuisine',
    'Enter the verification code (OTP) sent to':
        'Enter the verification code (OTP) sent to',
    'Cancellation policy': 'Cancellation policy',
    'Selected variation named': 'Selected variation named',
    'must be in between Minimum': 'must be in between Minimum',
    'and Maximum': 'and Maximum',
    'Add Ons (Optional)': 'Add Ons (Optional)',
    'Social Register': 'Social Register',
    'Social Login': 'Social Login',
    'Continue with facebook': 'Continue with facebook',
    'Password can not be updated while you are logged in by using social logins.':
        'Password can not be updated while you are logged in by using social logins.',
    'Previously added restaurant foods have been removed from cart. Now, try again.':
        'Previously added restaurant foods have been removed from cart. Now, try again.',
    'Order placement failed': 'Order placement failed',
    'Order placed successfully.': 'Order placed successfully.',
    referral: 'referral',
    Get: 'Get',
    'on joining': 'on joining',
    'Earn money on every referral': 'Earn money on every referral',
    'Refer your code to your friends': 'Refer your code to your friends',
    'Tap to copy': 'Tap to copy',
    'Your Referral Code': 'Your Referral Code',
    'Referral Code': 'Referral Code',
    'Referral code Copied': 'Referral code Copied',
    'Search suggestions are loading...': 'Search suggestions are loading...',
    'Your token has been expired.please sign in again':
        'Your token has been expired.please sign in again',
    'New On': 'New On',
    'Are you sure you want to delete your account?':
        'Are you sure you want to delete your account?',
    'Deliveryman tips': 'Deliveryman tips',
    'something went wrong.': 'something went wrong.',
    'No Address Found!': 'No Address Found!',
    'Please wait sometimes': 'Please wait sometimes',
    'No Cuisine Restaurant Found': 'No Cuisine Restaurant Found',
    'Cuisine Restaurant': 'Cuisine Restaurant',
    Cuisines: 'Cuisines',
    RecommendProduct: 'RecommendProduct',
    'Cancel Reason': 'Cancel Reason',
    'You can not Order more then  on COD order':
        'You can not Order more then  on COD order',
    'Cancellation Note': 'Cancellation Note',
    'Please select a cancellation reason':
        'Please select a cancellation reason',
    'Recommend Food': 'Recommend Food',
    'You can not Order more then': 'You can not Order more then',
    'on COD order': 'on COD order',
    include: 'include',
    'Order Type': 'Order Type',
    'Regular Order': 'Regular Order',
    Subscription: 'Subscription',
    'Enter Amount': 'Enter Amount',
    'Search...': 'Search...',
    'Add Fund to Wallet': 'Add Fund to Wallet',
    'Chat with admin': 'Chat with admin',
    ' Show less': ' Show less',
    '...Read more': '...Read more',
    'Add fund by from secured digital payment gateways':
        'Add fund by from secured digital payment gateways',
    'Faster & secure way to pay bill': 'Faster & secure way to pay bill',
    'Payment Methods': 'Payment Methods',
    'Subscription Order': 'Subscription Order',
    'Choose a delivery time': 'Choose a delivery time',
    'You must choose a subscription type':
        'You must choose a subscription type',
    'You must choose delivery days and times':
        'You must choose delivery days and times',
    'Your chosen delivery days and times must be in between start date and end date':
        'Your chosen delivery days and times must be in between start date and end date',
    'Your chosen delivery day and time must be in between start date and end date':
        'Your chosen delivery day and time must be in between start date and end date',
    'You must pick an end date': 'You must pick an end date',
    'You must pick a start date': 'You must pick a start date',
    '*Chose your preferable days and times to get your delivery':
        '*Chose your preferable days and times to get your delivery',
    'Subscription Details': 'Subscription Details',
    'Subscription id:': 'Subscription id:',
    'Created at:': 'Created at:',
    'Subscription date:': 'Subscription date:',
    'Subscription type:': 'Subscription type:',
    ' Subscription Schedule:': 'Subscription Schedule:',
    'Delivery Log': 'Delivery Log',
    'Pause Log': 'Pause Log',
    'Cancellation note can not be empty.':
        'Cancellation note can not be empty.',
    'This Subscription order cancelled successfully':
        'This Subscription order cancelled successfully',
    'Pause Subscription': 'Pause Subscription',
    'Cancel Subscription': 'Cancel Subscription',
    'Are you sure to pause subscription?':
        'Are you sure to pause subscription?',
    'Are you sure to cancel subscription?':
        'Are you sure to cancel subscription?',
    Reorder: 'Reorder',
    'Please select an option.': 'Please select an option.',
    Cancelled: 'Cancelled',
    'My Coupons': 'My Coupons',
    'Search location': 'Search location',
    'Order scheduled': 'Order scheduled',
    'Current orders can not be reordered as some changes occurred to the items.':
        'Current orders can not be reordered as some changes occurred to the items.',
    'No logs found': 'No logs found',
    'Reorder-able items added to the cart successfully.':
        'Reorder-able items added to the cart successfully.',
    'Additional Information': 'Additional Information',
    'Street number': 'Street number',
    'House number': 'House number',
    Included: 'Included',
    Excluded: 'Excluded',
    'This order can not be reordered as the restaurant is not existing in your current zone.':
        'This order can not be reordered as the restaurant is not existing in your current zone.',
    'ORDER TYPE &': 'ORDER TYPE &',
    'Delivery fee increased': 'Delivery fee increased',
    'due to bad weather.': 'due to bad weather.',
    'Start date and end date can not be same for subscription orders.':
        'Start date and end date can not be same for subscription orders.',
    'Recommended Food': 'Recommended Food',
    'Your Restaurants': 'Your Restaurants',
    'You have some foods in your cart. If you change your location, your cart and other data related to with your carrunt delivery location will be reset.':
        'You have some foods in your cart. If you change your location, your cart and other data related to with your carrunt delivery location will be reset.',
    'Custom Date': 'Custom Date',
    PAYMENT: 'PAYMENT',
    'Payment Option': 'Payment Option',
    'Payment Information': 'Payment Information',
    'Payment Information Updated': 'Payment Information Updated',
    'Find Nearby ': 'Find Nearby ',
    'Restaurant Near from You': 'Restaurant Near from You',
    Earn: 'Earn',
    ' when you ': ' when you ',
    'Refer an Friend': 'Refer an Friend',
    'Wanna Try  Again!': 'Wanna Try  Again!',
    'Get your recent food from the restaurant you recently visited':
        'Get your recent food from the restaurant you recently visited',
    'Let’s Try Something New': 'Let’s Try Something New',
    'Visit  Again!': 'Visit  Again!',
    'Get your desired item from your recent visit!':
        'Get your desired item from your recent visit!',
    'The Contact Person Info Is Required.':
        'The Contact Person Info Is Required.',
    'Verification Failed': 'Verification Failed',
    'Payment Verified': 'Payment Verified',
    'Verification Pending': 'Verification Pending',
    'Offline Payment': 'Offline Payment',
    'offline payment': 'offline payment',
    'See Location': 'See Location',
    "Offline Payment! Now, with just a click of a button, you can make secure transactions. It's simple, convenient, and reliable.":
        "Offline Payment! Now, with just a click of a button, you can make secure transactions. It's simple, convenient, and reliable.",
    'What’s on Your Mind?': 'What’s on Your Mind?',
    'Find Best Restaurants and Foods': 'Find Best Restaurants and Foods',
    Guest: 'Guest',
    'Pay Offline': 'Pay Offline',
    'Select option from below': 'Select option from below',
    Later: 'Later',
    'If you accidentally provided incorrect payment information, you can edit the details in the order details section while the order is still pending.':
        'If you accidentally provided incorrect payment information, you can edit the details in the order details section while the order is still pending.',
    'Your order is': 'Your order is',
    'You can use this ID to track your order later':
        'You can use this ID to track your order later',
    'View Order Details': 'View Order Details',
    'My Payment Information': 'My Payment Information',
    Information: 'Information',
    'Update Payment Info': 'Update Payment Info',
    Update: 'Update',
    search: 'search',
    'Our Latest Recommendations Just for You!':
        'Our Latest Recommendations Just for You!',
    'Explore More': 'Explore More',
    'Best Reviewed': 'Best Reviewed',
    'Popular Foods': 'Popular Foods',
    'Delete this address?': 'Delete this address?',
    No: 'No',
    'If you delete your account. All your data & history in this profile will be deleted':
        'If you delete your account. All your data & history in this profile will be deleted',
    'Delete Account': 'Delete Account',
    'Upload your photo': 'Upload your photo',
    'Choose Your Favourite Category': 'Choose Your Favourite Category',
    'Save Address': 'Save Address',
    'Want to remove this food your favourite list ?':
        'Want to remove this food your favourite list ?',
    'Remove this food': 'Remove this food',
    'Yes , Remove': 'Yes , Remove',
    'Please describe your problem to make you future experience more better':
        'Please describe your problem to make you future experience more better',
    'Remove this restaurant': 'Remove this restaurant',
    'Label As': 'Label As',
    'Order date:': 'Order date:',
    Summary: 'Summary',
    Instructions: 'Instructions',
    '6+ Character': '6+ Character',
    'My Profile': 'My Profile',
    'Update Address': 'Update Address',
    'I accept all the': 'I accept all the',
    'Insert delivery location': 'Insert delivery location',
    'Please add you delivery location so that we can review if the restaurant is available to deliver in your area or not  ':
        'Please add you delivery location so that we can review if the restaurant is available to deliver in your area or not  ',
    'Pick from Map': 'Pick from Map',
    'Filter: A to Z': 'Filter: A to Z',
    'Filter: Z to A': 'Filter: Z to A',
    'Price: Hight to Low': 'Price: Hight to Low',
    'Price: Low to High': 'Price: Low to High',
    'Order Place': 'Order Place',
    'Search categories ...': 'Search categories ...',
    'Go Back': 'Go Back',
    'Update Profile': 'Update Profile',
    'Change Password': 'Change Password',
    'Want to cancel the order ?': 'Want to cancel the order ?',
    Reason: 'Reason',
    Method: 'Method',
    'Unit Price ': 'Unit Price ',
    'Select from saved addresses': 'Select from saved addresses',
    'or pick from map': 'or pick from map',
    'Subscription Order Count': 'Subscription Order Count',
    'Subscription status:': 'Subscription status:',
    'Refund request': 'Refund request',
    'Subscription cancelled by:': 'Subscription cancelled by:',
    'Cancellation reason:': 'Cancellation reason:',
    'Please select a reason to cancel': 'Please select a reason to cancel',
    'Write your cancellation note': 'Write your cancellation note',
    'Continue with Google': 'Continue with Google',
    'Continue with Facebook': 'Continue with Facebook',
    'Don’t worry! Give your registered number & get OTP to update your password.':
        'Don’t worry! Give your registered number & get OTP to update your password.',
    'GET OTP': 'GET OTP',
    'Submit the OTP code sent to your registered phone number and verify':
        'Submit the OTP code sent to your registered phone number and verify',
    'Please allow browser location permission':
        'Please allow browser location permission',
    'Number verification is successful': 'Number verification is successful',
    'Please type your new password': 'Please type your new password',
    'Your browser location track permission is off. Please turn on the location permission to detect current location':
        'Your browser location track permission is off. Please turn on the location permission to detect current location',
    'Need any help ?': 'Need any help ?',
    'Communicate with our support team to get proper guidance to your questionaries':
        'Communicate with our support team to get proper guidance to your questionaries',
    'Call Us': 'Call Us',
    'Mail Us': 'Mail Us',
    'Session Time Out': 'Session Time Out',
    'Though it is a demo site, our system automatically reset after one hour and that’s why you logged out':
        'Though it is a demo site, our system automatically reset after one hour and that’s why you logged out',
    'Why am I seeing this?': 'Why am I seeing this?',
    'Proceed To Checkout': 'Proceed To Checkout',
    'Search restaurants....': 'Search restaurants....',
    'Select your location': 'Select your location',
    'Your Order is Pending, Please Wait for Restaurant Confirmation':
        'Your Order is Pending, Please Wait for Restaurant Confirmation',
    'insufficient amount': 'insufficient amount',
    'Please exchange more than ': 'Please exchange more than ',
    ' points': ' points',
    'Saved Address': 'Saved Address',
    'Promo Code': 'Promo Code',
    'Add Voucher': 'Add Voucher',
    'Service Charge': 'Service Charge',
    'Pick Location': 'Pick Location',
    'Theme Mode': 'Theme Mode',
    'Invalid phone number': 'Invalid phone number',
    'See Less': 'See Less',
    'See More': 'See More',
    'Weekly schedule': 'Weekly schedule',
    'You’ll get your order ': 'You’ll get your order ',
    ' at': ' at',
    daily: 'daily',
    'Total Order': 'Total Order',
    weekly: 'weekly',
    monthly: 'monthly',
    active: 'active',
    expired: 'expired',
    'Total Delivered': 'Total Delivered',
    Due: 'Due',
    'Log id': 'Log id',
    'Choose your preferable date range*': 'Choose your preferable date range*',
    'We will deliver here': 'We will deliver here',
    'Do you want to login or continue as a guest?':
        'Do you want to login or continue as a guest?',
    "If you log in, your order history will be saved. However, if you continue as a guest, you won't be able to see your order history after completing your order.":
        "If you log in, your order history will be saved. However, if you continue as a guest, you won't be able to see your order history after completing your order.",
    'Open Restaurant': 'Open Restaurant',
    'After completing the order, you will receive a':
        'After completing the order, you will receive a',
    'cashback. The minimum purchase required to avail this offer is':
        'cashback. The minimum purchase required to avail this offer is',
    'However, the maximum cashback amount is':
        'However, the maximum cashback amount is',
    'Extra Packaging': 'Extra Packaging',
    'Need Extra Packaging': 'Need Extra Packaging',
    'Whats on Your Mind?': 'Whats on Your Mind?',
    'Want to Dine in?': 'Want to Dine in?',
    'Todays Trends': 'Todays Trends',
    'New on': 'New on',
    'View Restaurants': 'View Restaurants',
    'Dine In': 'Dine In',
    'See our most popular restaurant and foods':
        'See our most popular restaurant and foods',
    'Currently Open': 'Currently Open',
    'View From Map': 'View From Map',
}
